import { AppState } from '@/store';
import ColorSwatch from '@components/ColorSwatch';
import FilterSidebar from '@components/tailwind/FilterSidebar';
import { useFilterItemUrl } from '@features/partner/hooks/useFilterItemUrl';
import {
  filtersAdd,
  filtersRemove,
  updateColorSelectionHistory,
} from '@features/partner/redux/partner.actions';
import React, { useState, useEffect, memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';

const MIN_COUNT_SHOW = 20;

type Props = {
  rel?: string;
};

const ColorsList = ({ rel }: Props) => {
  const dispatch = useAppDispatch();
  const {
    sidebarFilters: { colors },
    filterOptions: { colors: colorsSelected },
  } = useSelector((state: AppState) => state.partner);
  const { getUrl } = useFilterItemUrl();

  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (colors) {
      setIsExpanded(!(colors.length > MIN_COUNT_SHOW));
    }
  }, [colors]);

  const colorChangeHandler = (color) => () => {
    const colorId = color?.id;
    if (!colorId) return;

    if (colorsSelected.indexOf(colorId as never) >= 0) {
      dispatch(filtersRemove('colors', colorId));
      dispatch(updateColorSelectionHistory(colorId, true));
    } else {
      dispatch(filtersAdd('colors', colorId));
      dispatch(updateColorSelectionHistory(colorId));
    }
  };

  if (!colors || colors.length <= 0) return null;

  return (
    <FilterSidebar title='Color'>
      <div className='tw-flex tw-flex-wrap tw-gap-3'>
        {colors.slice(0, isExpanded ? colors.length : MIN_COUNT_SHOW).map((color) => (
          <ColorSwatch
            fakeHref={getUrl(colorsSelected.indexOf(color.id) >= 0 ? 'remove' : 'add', 'colors', color?.id)}
            key={color.id}
            itemHandler={colorChangeHandler}
            color={{ ...color, formattedValue: color.value } as any}
            isActive={colorsSelected.indexOf(color.id as never) >= 0}
            ignoreDisabledStyle
            {...{ rel }}
          />
        ))}
      </div>

      {colors?.length > MIN_COUNT_SHOW && (
        <p
          onClick={() => setIsExpanded(!isExpanded)}
          className='tw-mt-5 tw-cursor-pointer tw-font-body tw-text-sm tw-font-bold tw-text-body tw-underline'>
          {isExpanded ? '- Show Less Colors' : '+ Show More Colors'}
        </p>
      )}
    </FilterSidebar>
  );
};

export default memo(ColorsList);
